import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import {
  Button,
  Flex,
  MobileThemeProvider,
  TextArea,
  ThemeProvider,
} from '@amzn/storm-ui';
import {
  getAttributeEventTarget,
  getChromeConfiguration,
  KeyValue,
  setChromeConfiguration,
  Toggle,
} from '@amzn/aac-chrome-api';
import {
  initChromeFooter,
  initChromeHeader,
  initChromeNav,
  initChromePivotNav,
} from 'src/index';
import {
  cbSampleConfig,
  cmSampleConfig,
  initialSampleCode1,
} from './codeExamples';
import { StyledLink } from 'src/commons/components/StyledLink';

const addToggleEventListener = (toggleProperties, toggleFunction) => {
  const attributeEventTarget = getAttributeEventTarget();
  const toggleEventListener = () => {
    if (toggleProperties.onClick) toggleFunction();
  };
  attributeEventTarget.addEventListener(
    toggleProperties.id,
    toggleEventListener,
  );
};

const setInitialChromeConfig = ({
  initialChromeConfig,
  isActive,
  valueLabel,
  valueStyle,
  setIsActive,
  setValueLabel,
  setValueStyle,
}) => {
  const pageHeader = initialChromeConfig.getPageHeader();
  const objectInfo = pageHeader.getObjectInfo();
  const toggleAttributes = new Toggle();
  toggleAttributes.setId('toggle-status');
  toggleAttributes.setIsActive(isActive);
  const keyValueAttributes = new KeyValue();
  keyValueAttributes.setId('subscription-status');
  keyValueAttributes.setKey('key');
  keyValueAttributes.setValue(valueLabel);
  keyValueAttributes.setValueStyle(valueStyle);
  addToggleEventListener(toggleAttributes, () => {
    setIsActive(!isActive);
    setValueLabel('value loaded');
    setValueStyle('SUCCESS');
  });
  objectInfo.setAttributes([
    toggleAttributes,
    keyValueAttributes,
    ...objectInfo.attributes.list,
  ]);
  pageHeader.setObjectInfo(objectInfo);
  initialChromeConfig.setPageHeader(pageHeader);
  initialChromeConfig.setHmhEnabled(true);
  setChromeConfiguration(initialChromeConfig);
};

const DevPage = () => {
  const [isActive, setIsActive] = useState(true);
  const [valueLabel, setValueLabel] = useState('value not load');
  const [valueStyle, setValueStyle] = useState('WARNING');

  const initialChromeConfig = getChromeConfiguration();

  setInitialChromeConfig({
    initialChromeConfig,
    isActive,
    valueLabel,
    valueStyle,
    setIsActive,
    setValueLabel,
    setValueStyle,
  });

  const executeCode = () => {
    const playgroundElement = document.getElementById(
      'js-playground',
    ) as HTMLInputElement;
    eval(playgroundElement.value);
  };

  const executeInitialLayout = () => {
    const playgroundElement = document.getElementById(
      'js-playground',
    ) as HTMLInputElement;
    playgroundElement.value = initialSampleCode1;
    setInitialChromeConfig({
      initialChromeConfig,
      isActive,
      valueLabel,
      valueStyle,
      setIsActive,
      setValueLabel,
      setValueStyle,
    });
  };

  const executeCMLayout = () => {
    const playgroundElement = document.getElementById(
      'js-playground',
    ) as HTMLInputElement;
    playgroundElement.value = cmSampleConfig;
    eval(cmSampleConfig);
  };

  const executeCBLayout = () => {
    const playgroundElement = document.getElementById(
      'js-playground',
    ) as HTMLInputElement;
    playgroundElement.value = cbSampleConfig;
    eval(cbSampleConfig);
  };

  return (
    <ThemeProvider enableThemeModes>
      <MobileThemeProvider>
        <Flex
          direction="column"
          alignItems="flex-start"
          gap="xsmall"
          padding="base"
          style={{
            marginBottom: '100px',
          }}
        >
          <TextArea
            id="js-playground"
            label="chrome-playground"
            hideLabel
            fullWidth
            style={{ height: '500px', fontFamily: 'monospace' }}
          >
            {initialSampleCode1}
          </TextArea>
          <Flex gap="xxsmall">
            <Button
              id="js-playground-execute"
              onClick={executeCode}
              variant="primary"
            >
              Execute above code
            </Button>
            <Button id="js-playground-initial" onClick={executeInitialLayout}>
              Reset config & sample code
            </Button>
            <Button id="js-playground-cm" onClick={executeCMLayout}>
              Set CM sample layout
            </Button>
            <Button id="js-playground-cb" onClick={executeCBLayout}>
              Set CB sample layout
            </Button>
          </Flex>
          <StyledLink
            href="https://console.harmony.a2z.com/ccx-chrome-documentation/docs/ClientSideApi/ChromeConfiguration/ChromeConfiguration"
            target="_blank"
          >
            Link to chrome config doc site
          </StyledLink>
        </Flex>
      </MobileThemeProvider>
    </ThemeProvider>
  );
};

const localDevPage = () => {
  const render = () => {
    const container = document.getElementById('AACApplicationBodyDevPage');
    if (container) {
      ReactDOM.render(<DevPage />, container);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
};

export {
  initChromeHeader,
  initChromePivotNav,
  initChromeFooter,
  initChromeNav,
  localDevPage,
};
